/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Add_Member_Validation_Select_RequiredInputs */



/**
* | output |
* | --- |
* | "Please select a member to add" |
*
* @param {Teams_Add_Member_Validation_Select_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_add_member_validation_select_required = /** @type {((inputs?: Teams_Add_Member_Validation_Select_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Add_Member_Validation_Select_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie ein Mitglied zum Hinzufügen aus")
	return /** @type {LocalizedString} */ ("Please select a member to add")
});